define('mrg-smokescreen/Honeypot', ['OK/logger'], function(logger) {
    function parseConfig(data) {
        var RE_TAG     = /^([a-z][a-z0-9]*)/g;
        var RE_CLASS   = /^\.([A-z0-9\-\_]+)/g;
        var RE_ID      = /^#([A-z0-9\-\_]+)/g;
        var RE_ATTRS   = /^@([A-z0-9\-\_]+)="((?:[^"\\]|\\.)*)"/g;
        var RE_MULTI   = /^\*(\d+)/g;

        var RE_QUOTES = new RegExp('"', 'g');
        var RE_SPACES = /\s+/;

        return data.map(function(str) {
            var parts = str.split(RE_SPACES);

            // внутри кавычек разрешены пробелы
            var quotes = (str.match(RE_QUOTES) || []).length;
            if(quotes > 0 && quotes % 2 === 0) {
                var odd = null;

                for(var i = 0; i < parts.length; i++) {
                    if(odd === null) {
                        var sub_quotes = (parts[i].match(RE_QUOTES) || []).length;

                        if(sub_quotes && sub_quotes % 2) {
                            odd = i;
                        }

                    } else {
                        parts[odd] += ' ' + parts[i];

                        if(parts[i].indexOf('"') !== -1) {
                            odd = null;
                        }

                        parts[i] = undefined;
                    }
                }
            }

            return parts.filter(function(part) { return part }).map(function(part) {
                if(part) {
                    var match, res = {
                        multi: 1
                    };

                    do {
                        RE_TAG.lastIndex = 0;
                        RE_CLASS.lastIndex = 0;
                        RE_ID.lastIndex = 0;
                        RE_ATTRS.lastIndex = 0;
                        RE_MULTI.lastIndex = 0;

                        if(match = RE_TAG.exec(part)) {
                            part = part.substr(RE_TAG.lastIndex);

                            res.tag = match[1];

                        } else if(match = RE_CLASS.exec(part)) {
                            part = part.substr(RE_CLASS.lastIndex);

                            res.classes = res.classes || [];
                            res.classes.push(match[1]);

                        } else if(match = RE_ID.exec(part)) {
                            part = part.substr(RE_ID.lastIndex);

                            res.id = match[1];

                        } else if(match = RE_ATTRS.exec(part)) {
                            part = part.substr(RE_ATTRS.lastIndex);

                            res.attrs = res.attrs || {};
                            res.attrs[match[1]] = match[2].replace(/\\/g, "");

                        } else if (match = RE_MULTI.exec(part)) {
                            part = part.substr(RE_MULTI.lastIndex);

                            res.multi = parseInt(match[1]);
                        }

                    } while(match && part.length);

                    if(part.length) {
                        throw new Error('Unparsed template: "' + part + '"');
                    }

                    return res;
                }
            });
        });
    }

    function buildDom(conf) {
        var baits = [], childs = [];

        var data;
        while(data = conf.pop()) {
            var node = document.createElement(data.tag || 'div');

            if(!data.attrs) {
                data.attrs = {};
            }

            if(data.id) {
                data.attrs.id = data.id;
            }

            if(data.classes) {
                data.attrs['class'] = data.classes.join(' ');
            }

            for(var i in data.attrs) {
                if(data.attrs.hasOwnProperty(i) && i !== 'length') {
                    node.setAttribute(i, data.attrs[i]);
                }
            }

            childs.forEach(function(child) {
                node.appendChild(child);
            });
            childs = [];

            baits.push(node);
            childs.push(node);

            for(var i=1; i < data.multi; i++) {
                var clone = node.cloneNode(true);
                baits.push(clone);
                childs.push(clone);
            }
        }

        return {
            baits: baits,
            nodes: childs
        };
    }

    function prepareStyles(config) {
        return {
            available: typeof window.getComputedStyle === 'function',

            styles: (config || []).map(function(line) {
                var data = line.split(/\s*:\s*/);

                return {
                    field: data[0],
                    value: data[1]
                }
            })
        };
    }

    function checkVisibility(bait) {
        return bait.offsetParent === null;
    }

    function applyStyles(bait, config) {
        if(config.available) {
            config.styles.forEach(function (style) {
                bait.style[style.field] = style.value;
            });
        }
    }

    function checkStyles(bait, config) {
        var detect;

        if(config.available) {
            var computed = window.getComputedStyle(bait, null);

            config.styles.forEach(function(style) {
                if(!detect) {
                    detect = computed[style.field] !== style.value && computed[style.field] !==  'auto';
                }
            });
        }

        return detect;
    }

    function checkJS(config) {
        if((config || '').length) {
            try {
                var RE = new RegExp(config);

                return Object.keys(window).filter(function(field) {
                    return field.match(RE);

                }).length > 0;

            } catch(e) {
            }
        }
    }

    return {
        version: "1.3.0",

        check: function(baitsConfig, cssConfig, jsConfig) {
            var body = document.getElementsByTagName('body')[0];

            if(body) {
                try {
                    var rules = parseConfig(baitsConfig);
                    var styles = prepareStyles(cssConfig) ;

                    if(checkJS(jsConfig)) {
                        return true;
                    }

                    var baits = [];
                    var fragments = [];

                    for(var i=0; i < rules.length; i++) {
                        if(rules[i] && rules[i].length) {
                            var div = buildDom(rules[i]);

                            if(div.nodes && div.baits && div.baits.length) {
                                var fragment = document.createElement('div');
                                fragment.style.position = 'absolute';
                                fragment.style.visibility = 'hidden';
                                fragment.style.top = '0';
                                fragment.style.left = '0';

                                div.nodes.forEach(function(node) {
                                    fragment.appendChild(node);
                                });
                                body.appendChild(fragment);

                                div.baits.forEach(function(bait) {
                                    applyStyles(bait, styles);
                                });

                                baits = baits.concat(div.baits);
                                fragments.push(fragment);
                            }
                        }
                    }

                    //
                    // Блокировщики применяют некоторые правила скрытия стилями не сразу при добавлении элемента в DOM, а асинхронно
                    // по команде от MutationObserver-а. Поэтому проверку видимости/стилей производим через небольшой промежуток времени
                    //
                    return new Promise(function (resolve) {
                        // По таймауту проверяем приманки и удаляем их со страницы
                        window.setTimeout(function () {
                            var detect = false;
                            baits.forEach(function(bait) {
                                if (checkVisibility(bait) || checkStyles(bait, styles)) {
                                    detect = true;
                                }
                            });

                            fragments.forEach(function (fragment) {
                                body.removeChild(fragment);
                            });

                            resolve(detect === true);
                        },
                        100);
                    });
                } catch(e) {
                    logger.success("nb_error", "honeypot", e);
                }

                return false;
            }
        }
    }
});